/*
 * 產品頁選項掣直接寫價錢差（sections/main-product.liquid variant_picker：button 款、多過一個 variant 先載）
 *
 *   Rybbit 2026-09-24 → 10-01：Safari / Chrome 改過選項但冇加入購物車嘅客，55% 最後一個動作就係轉選項；
 *   有客 21 秒內轉物料 13 次、尺寸撳嚟撳去 —— 掣上面冇價錢，要逐粒撳嚟比價。
 *   而家未揀嗰啲掣寫埋「+$700」/「−$300」（同而家揀緊嘅比），同價唔寫；
 *   有依賴嘅選項（im-option-groups「只有 201cm」）照用嗰邊嘅自動轉法計價。
 *   每次揀款 Rybbit 記 pdp_option（option / value / delta = 撳之前掣上面寫緊嘅價錢差）。
 *
 *   ImOptionPrices（純函數，tests/option-picker.cjs 測）：
 *     targetFor(variants, selection, index, value, linked) → 撳呢粒掣之後會係邊個 variant
 *     deltaText(cents)                                    → '+$700' / '−$300' / ''
 */
(function (root) {
  function sameOptions(v, selection) {
    for (var j = 0; j < selection.length; j++) {
      if (v.options[j] !== selection[j]) return false;
    }
    return true;
  }

  function targetFor(variants, selection, index, value, linked) {
    var want = selection.slice();
    want[index] = value;
    var exact = variants.find(function (v) { return sameOptions(v, want); });
    if (exact) return exact;
    if (linked && root.ImOptionGroups) return root.ImOptionGroups.bestFor(variants, selection, index, value);
    return null;
  }

  function deltaText(cents) {
    var dollars = Math.round(cents / 100);
    if (!dollars) return '';
    return (dollars > 0 ? '+$' : '−$') + Math.abs(dollars).toLocaleString('en-US');
  }

  root.ImOptionPrices = { targetFor: targetFor, deltaText: deltaText };
})(typeof window !== 'undefined' ? window : this);

(function () {
  if (typeof document === 'undefined') return;
  var P = window.ImOptionPrices;

  function track(props) {
    try { if (window.rybbit && typeof window.rybbit.event === 'function') window.rybbit.event('pdp_option', props); } catch (e) {}
  }

  function initialize(root) {
    root.querySelectorAll('variant-radios').forEach(function (picker) {
      if (picker.dataset.imPricesReady) return;
      var data = picker.querySelector('script[type="application/json"]');
      if (!data) return;
      var variants = JSON.parse(data.textContent);
      if (!Array.isArray(variants) || variants.length < 2) return;
      var linked = picker.hasAttribute('data-im-option-groups');
      var fieldsets = Array.from(picker.querySelectorAll('fieldset'));

      function selection() {
        return fieldsets.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : undefined; });
      }

      function update() {
        var current = selection();
        var base = variants.find(function (v) {
          return v.options.every(function (o, j) { return o === current[j]; });
        });
        fieldsets.forEach(function (fieldset, index) {
          fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
            var label = input.nextElementSibling;
            if (!label || label.tagName !== 'LABEL') return;
            var text = '';
            if (base && !input.checked && !input.disabled && !label.classList.contains('im-opt--needs')) {
              var target = P.targetFor(variants, current, index, input.value, linked);
              if (target) text = P.deltaText(target.price - base.price);
            }
            var tag = label.querySelector('.im-opt-delta');
            if (!text) { if (tag) tag.remove(); return; }
            if (!tag) {
              tag = document.createElement('span');
              tag.className = 'im-opt-delta';
              label.appendChild(tag);
            }
            tag.textContent = text;
          });
        });
      }

      picker.addEventListener('change', function (event) {
        var input = event.target;
        if (!input.matches || !input.matches('input[type="radio"]')) return;
        var label = input.nextElementSibling;
        var tag = label && label.querySelector('.im-opt-delta');
        track({ option: input.name, value: input.value, delta: tag ? tag.textContent : '' });
        // 等 im-option-groups 同 Dawn 處理完（可能自動轉咗其他選項）先重新計
        setTimeout(update, 0);
      });
      picker.dataset.imPricesReady = 'true';
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
